import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";

gsap.registerPlugin(MorphSVGPlugin);

let prevId = null;
const icons = ["#bulletin", "#directory", "#essay", "#flower"];

const getRandomId = () => {
  const targetIndex = Math.floor(Math.random() * icons.length);
  let target = icons[targetIndex];
  if (target === prevId) {
    target = targetIndex === icons.length ? icons[0] : icons[targetIndex + 1];
  }
  return target;
};

const callTween = (id) => {
  prevId = id;
  const nextId = getRandomId();

  gsap.to("#bulletin", {
    morphSVG: nextId,
    duration: 2,
    ease: "expo.inOut",
    onComplete: () => {
      gsap.delayedCall(2, callTween, [nextId]);
    },
  });
};

// IIFE - just run on page load
(function () {
  callTween("#bulletin");
})();
